// @flow
import React from 'react';

import { EstimateContextProvider } from '../../contexts/EstimateContextProvider';
import { MonthlyInputsMetaDataContextProvider } from '../../contexts/MonthlyInputsMetaDataContextProvider';
import { EstimateBreadcrumbs } from '../breadcrumbs/EstimateBreadcrumbs';
import { ShowLoaderIfAnyQueryIsPending } from '../presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '../../contexts/UserContextProvider';
import { AiAssistantEstimateContextBridge } from '../ai-assistant/AiAssistantEstimateContextBridge';

import EstimateTopLevelContainerForm from './EstimateTopLevelContainerForm';

const EstimateTopLevelContainer = () => {
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <EstimateContextProvider>
          <AiAssistantEstimateContextBridge />
          <MonthlyInputsMetaDataContextProvider>
            <EstimateBreadcrumbs />
            <EstimateTopLevelContainerForm />
          </MonthlyInputsMetaDataContextProvider>
        </EstimateContextProvider>
      </UserContextProvider>
    </>
  );
};

export default EstimateTopLevelContainer;
